import Axios from 'axios'
import React, { Component } from 'react'
import { getUser } from '../../actions/session'
import { RATEDECK_LISTING } from '../../config/rest_endpoints'
import Container from '../common/application_container'
import CustomLoader from '../common/loader'
import CustomModal from '../common/modal'
import RateDeckAddForm from './addForm'
import Pagination from "react-js-pagination";



class RateDeckListing extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User:getUser(),
            tableData:[],
            isGetting:false,
            isModal:false,
            activePage: 1,
            itemsCount: 10,
            totalCount: null,
        }
        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.getRatedeckList = this.getRatedeckList.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    componentDidMount() {
        this.getRatedeckList()
    }

    openModal() {
        this.setState({isModal:true})
    }

    closeModal() {
        this.setState({isModal:false})
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.getRatedeckList()
        });
    }

    getRatedeckList() {
        const {User,activePage,itemsCount} = this.state
        this.setState({isGetting:true})
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.get(`${RATEDECK_LISTING}?page=${activePage}&limit=${itemsCount}`,{headers}).then(res=>{
            if(res) {
                console.log('res :>> ', res);
                var resp = res.data.data
                this.setState({tableData:resp, isGetting:false, totalCount:res.data.pageinfo.totalCount})
                console.log('totalcount :>> ', this.state.totalCount);
            }
        }).catch(err=>{
            console.log('err :>> ', err);
        })
    }

    renderTableData() {
        const {tableData} = this.state
        if(tableData === null ) {
            return (
                <div className="ml-4 mt-2">
                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div>
            )
        }
        else {
            return tableData.map((row,idx)=>{
                return(
                    <tr key={idx}>
                        <td>{row.tpID}</td>
                        <td>{row.csvName}</td>
                        <td>{row.path}</td>
                        <td>{row.status}</td>
                        <td>{row.connectFee}</td>
                        <td>{row.initialInc}</td>
                        <td>{row.subsequentInc}</td>
                        <td>{row.roundingMethod}</td>
                        <td>{row.roundingDigits}</td>
                        <td>{row.RecordTime}</td>
                    </tr>
                )
            })
        }
    }
    
    render() {
        const {isGetting, isModal} = this.state
        let addRateDeck = {
            details: {
                info: "Add RateDeck",
                msg: <RateDeckAddForm listing={this.getRatedeckList} close={this.closeModal} />
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeModal },
            cancelBtn: { label: "Cancel", action: this.closeModal }
        }

        return (
            <Container title="Rate Deck" icon="fa fa-bars">
                <CustomModal
                    visibility={isModal}
                    customBodyCSS={"h20"}
                    modalType={"success"}
                    details={addRateDeck.details}
                    modalSize={"large"}
                    showBtns={false}
                    cancelBtn={addRateDeck.cancelBtn}
                    crossBtn={addRateDeck.crossBtn}
                />
                <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                        <h5 style={{fontWeight:'600',fontSize:'14px',color:'#0F172A',margin:0}}>Rate Deck Table</h5>
                        <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
                            <div className="input-group" style={{maxWidth:'260px'}}>
                                <input type="search" className="form-control border-right-0" placeholder="Type to filter..." onChange={this.searchSpace} />
                                <span className="input-group-append">
                                    <button className="btn" type="button" style={{background:'linear-gradient(135deg, #10B981, #059669)',color:'#fff',border:'none',borderRadius:'0 8px 8px 0'}}><i className="fa fa-search"></i></button>
                                </span>
                            </div>
                            <button type="button" style={{background:'linear-gradient(135deg, #10B981, #059669)',color:'#fff',border:'none',borderRadius:'10px',padding:'8px 18px',fontSize:'13px',fontWeight:'500',cursor:'pointer',boxShadow:'0 2px 8px rgba(16,185,129,0.25)'}} onClick={this.openModal}>Add RateDeck <i className="fas fa-plus ml-2"></i></button>
                        </div>
                    </div>
                    <div style={{overflowX:'auto'}}>
                        <table className="table table-striped" style={{margin:0}}>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Csv Name</th>
                                    <th>Path</th>
                                    <th>Status</th>
                                    <th>Connect Fee</th>
                                    <th>Initial Inc</th>
                                    <th>Subsequent Inc</th>
                                    <th>Rounding Method</th>
                                    <th>Rounding Digits</th>
                                    <th>Record Time</th>
                                </tr>
                            </thead>
                            <tbody>
                               {isGetting ? <CustomLoader /> :this.renderTableData()}
                            </tbody>
                        </table>
                    </div>
                    {this.state.totalCount > 9 ?
                        <div style={{padding:'12px 20px',borderTop:'1px solid #F1F5F9'}}>
                            <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsCount}
                                totalItemsCount={this.state.totalCount}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange.bind(this)}
                            />
                        </div> : ''
                    }
                </div>
            </Container>
        )
    }
}
export default RateDeckListing